export default __webpack_public_path__ + "static/news11-2d944b814c718319643a45a5c1cd15cb.png";